module.exports = __webpack_public_path__ + "img/gateway-green.0a082628.png";